/* Action Types */
export const CALL_USER_CPF_VALIDATION = 'CALL_USER_CPF_VALIDATION';
export const USER_CPF_VALIDATION_SUCCESS = 'USER_CPF_VALIDATION_SUCCESS';
export const USER_CPF_VALIDATION_FAILED = 'USER_CPF_VALIDATION_FAILED';
export const VALIDATE_USER_PASSWORD_RESPONSE = 'VALIDATE_USER_PASSWORD_RESPONSE';
export const PASSWORD_CONFIRMATION = 'PASSWORD_CONFIRMATION';
export const PASSWORD_CONFIRMATION_RESPONSE = 'PASSWORD_CONFIRMATION_RESPONSE';

/* Reducer */
const INITIAL_STATE = {
    cpf: {
        loading: false,
        status: 'success',
        message: null,
        error: null
    },
    password: {
        power: 0,
        status: 'normal',
        message: '',
        value: ''
    },
    passwordConfirmation: {
        status: '',
        message: '',
        value: '',
        confirmation: ''
    }
};

export default function reducer(state = INITIAL_STATE, action) {
    const { message, error, type, power, status, password, confirmation } = action;

    switch (type) {
        case CALL_USER_CPF_VALIDATION:
            return { ...state,
                        cpf: {
                            loading: true,
                            status: 'validating'
                        }
                    };
        case USER_CPF_VALIDATION_SUCCESS:
            return { ...state,
                cpf: {
                    loading: false,
                    status: 'success',
                    message
                }
            };
        case USER_CPF_VALIDATION_FAILED:
            return { ...state,
                cpf: {
                    loading: false,
                    status: 'error',
                    message,
                    error
                }
            };
        case VALIDATE_USER_PASSWORD_RESPONSE:
            return { ...state,
                password: {
                    power,
                    status,
                    message
                }

            };
        case PASSWORD_CONFIRMATION:
            return { ...state,
                passwordConfirmation: {
                    status: 'validating',
                    value: password,
                    confirmation
                }
            }
        case PASSWORD_CONFIRMATION_RESPONSE:
            return { ...state,
                passwordConfirmation: {
                    status,
                    message
                }
            }
        default:
            return state;
    }
}

/* Action Creators */

export const userCpfValidation = data => {
    return { type: CALL_USER_CPF_VALIDATION, data }
};

export const userCpfValidationSuccess = message => {
    return { type: USER_CPF_VALIDATION_SUCCESS, message }
};

export const userCpfValidationFaild = message => {
    return { type: USER_CPF_VALIDATION_FAILED, message }
};

export const validateUserPasswordPowerResponse = data => {
    return { type: VALIDATE_USER_PASSWORD_RESPONSE, ...data }
};

export const passwordConfirmation = data => {
    return { type: PASSWORD_CONFIRMATION, ...data }
}
export const passwordConfirmationResponse = data => {
    return { type: PASSWORD_CONFIRMATION_RESPONSE, ...data }
}



// WEBPACK FOOTER //
// ./src/ducks/inputValidations.js